// cry(추모관) FE 분해 Phase 1 (untangle) — cry 도메인 전용 API 엔드포인트.
// 추모관 별도 앱 추출 대비: cry(memorial/funeral/announcement/anniversary) 엔드포인트를 apiList.js 에서 분리.
// apiList.js 는 이들을 re-export 하므로 기존 `import { memorial } from '@/common/service/apiList'` 는 그대로 동작.
// ⚠️ 공유(smile 등과 겸용) emoticon·item·church 는 여기로 옮기지 않음(순수 cry 아님).

export const memorial = {
  getList: '/api/memorial',
  // HTTP METHOD : GET
  // PARAMETERS : MemorialParameter,
  getDetail: '/api/memorial/',
  // HTTP METHOD :GET
  // Path : MemorialNo,
  getChurchMemorials: '/api/memorial/church',
  // HTTP METHOD : GET
  // PARAMETERS : page,limit,churchNo,
  // 260903 교회 성도 코드(코드=자격). 반드시 4세그먼트('/api/memorial/church/xxx')로 둔다 —
  //   security.yaml 의 "/api/memorial/*"(Ant 1세그먼트) 와일드카드에 걸리면 인증 없이 열린다.
  //   '/save'·'/update' 로 끝내지 않는 것도 같은 이유(xss-ignore glob 이 필터체인을 통째로 걷어낸다).
  churchStatus: '/api/memorial/church/status',
  // HTTP METHOD : GET — 내 교회 성도 자격. → { entitled, churchName }  ⚠️키는 entitled 다(active 아님)
  churchRedeem: '/api/memorial/church/redeem',
  // HTTP METHOD : POST — { code, qrCode? } → { churchName }
  churchGrant: '/api/memorial/church/grant',
  // 260904 온라인 추모관 교회 목록(공개). 위 성도 축과 반대로 **일부러 3세그먼트**다 —
  //   security.yaml "/api/memorial/*"(Ant 1세그먼트)에 걸려 게스트(QR 스캔)도 읽는다. 응답은 교회명·건수뿐.
  churchList: '/api/memorial/churches',
  // HTTP METHOD : GET → [{ churchNo(앵커 없으면 null), churchName, memorialCount }] 교회명순
  // HTTP METHOD : POST — 저장 직전 1회용 그랜트 토큰 발급. → { grantToken, expiresInMinutes }  ⚠️키는 grantToken 이다(token 아님)
  // 260902 조문 목록이 인증 뒤로 이동(BE MemorialCommentController @GetMapping("/list")).
  //   경로를 한 세그먼트 늘려 security.yaml 의 "/api/memorial/*"(Ant 1세그먼트) 밖으로 뺀 것 — 짝으로 맞춘다.
  //   헌화 쓰기(sendComment)는 비로그인 유지라 경로 변경 없음.
  getComment: '/api/memorial/comment/list',
  // HTTP METHOD : GET
  // page,limit
  pushComment: '/api/memorial/comment/send',
  // HTTP METHOD : POST
  // PARAMETERS : memorialNo,templateNo,userNo,emoticonNo,userName,commentType
  getAliveList: '/api/memorial/alive',
  // HTTP METHOD : GET
  // page,limit,memorialNo
  getAliveDetail: '/api/memorial/alive/',
  // HTTP METHOD : GET
  // PathVariable : aliveNo
  addReport: '/api/memorial/alive/report',
  // HTTP METHOD : POST
  // aliveNo,reason,reporter,writer
  deleteAlive: aliveNo => `/api/memorial/alive/delete/${aliveNo}`,
  // HTTP METHOD : PATCH
  // PathVariable : aliveNo,
  deleteMemorial: '/api/memorial/delete/',
  // HTTP METHOD : PATCH
  // PathVariable : memorialNo
  saveMemorial: '/api/memorial/save',
  // HTTP METHOD : POST,
  editMemorial: '/api/memorial/update',
  // HTTP METHOD : PUT
  saveAlive: '/api/memorial/alive/save',
  updateAlive: '/api/memorial/alive/update',
  getHistoryList: '/api/user/memorial/history',
  // HTTP METHOD : GET,
  // PARAMETER : familyCode,page,limit
  getBackground: userNo => `/api/image/background/${userNo}`,
  getAndersenBackground: `/api/image/background/andersen`,
  // getBackgroundVideo: '/api/image/background/video',
  getBackgroundVideo: userNo => `/api/image/background/video/${userNo}`,
  // HTTP METHOD :GET,
  // PATH_VARIABLE : userNo
  getFrame: '/api/image/frame'
  // HTTP METHOD :GET
};

export const anniversary = {
  getAnniversary: memorialNo => `/api/memorial/anniversary/${memorialNo}`
};

export const funeral = {
  excelDownload: funeral => `/api/funeral/${funeral}/download`,
  getList: '/api/funeral',
  getDetail: '/api/funeral/',
  pushComment: '/api/funeral/comment/send',
  // HTTP METHOD : POST
  // PARAMETERS : funeralNo,templateNo,userNo,emoticonNo,type ( Message 인지 Emoticon 인지 )
  removeComment: '/api/funeral/comment/remove/',
  // HTTP METHOD : DELETE
  // PATH : commentNo
  removeFuneral: '/api/funeral/delete/',
  // HTTP METHOD : PATCH
  // PATH : funeralNo,

  // HTTP METHOD : PATCH
  // PATH : announcementNo
  saveFuneral: '/api/funeral/save',
  // HTTP METHOD : POST
  updateFuneral: '/api/funeral/update'
  // HTTP METHOD : PUT
  // HTTP METHOD : PUT
};

export const announcement = {
  getAnnouncementList: '/api/announcement',
  getAnnouncement: announcementNo => `/api/announcement/${announcementNo}`,
  save: '/api/announcement/save',
  update: '/api/announcement/update',
  download: '/api/wreath/announcement/download',
  remove: announcementNo => `/api/announcement/delete/${announcementNo}`
};
